// 汗汗虫虫漫画 - 首页展示数据

export const heroStats = [
  { value: "12.6w+", label: "在追作品" },
  { value: "380w+", label: "更新提醒推送" },
  { value: "92%", label: "追更不错过率" },
  { value: "<2s", label: "更新通知延迟" },
];

export const features = [
  {
    icon: "ri-notification-3-line",
    title: "更新提醒",
    desc: "开启后，作品一有章节更新便第一时间推送提醒，无需反复刷新页面，重要更新一个都不漏。",
  },
  {
    icon: "ri-settings-3-line",
    title: "追更设置",
    desc: "灵活调整每部作品的提醒方式、推送时间与静默时段，按你的追更习惯自由定制。",
  },
  {
    icon: "ri-flashlight-line",
    title: "最新章节推送",
    desc: "最新章节到达即实时推送，点开即可续读，追更进度永远保持最新状态。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "追更日历",
    desc: "用日历整理所有在追作品，哪部周几更新一目了然，更新状态随时掌握。",
  },
  {
    icon: "ri-list-check-3",
    title: "订阅管理",
    desc: "所有订阅集中管理，一键开启或暂停，随时查看提醒频率与通知记录。",
  },
  {
    icon: "ri-book-open-line",
    title: "自动续读",
    desc: "自动续读帮你接上上次阅读进度，换设备也能无缝续读，不重复找章节。",
  },
];

export const works = [
  {
    id: 1,
    title: "星辰炼金师",
    category: "奇幻冒险",
    status: "连载中",
    latestChapter: "第 168 话 · 星陨之核",
    updateDay: "每周三更新",
    tags: ["魔法", "成长", "冒险"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20fantasy%20manga%20comic%20cover%20art%20of%20a%20young%20alchemist%20girl%20holding%20a%20glowing%20star%20crystal%2C%20vibrant%20coral%20and%20warm%20amber%20color%20palette%2C%20dynamic%20stylized%20comic%20illustration%2C%20dramatic%20lighting%2C%20energetic%20manga%20poster%20style&width=600&height=800&seq=work-cover-01&orientation=portrait",
  },
  {
    id: 2,
    title: "校园异能日记",
    category: "青春校园",
    status: "连载中",
    latestChapter: "第 92 话 · 期末风暴",
    updateDay: "每周一、四更新",
    tags: ["校园", "超能力", "日常"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20school%20comedy%20manga%20comic%20cover%20of%20a%20cheerful%20high%20school%20student%20surrounded%20by%20floating%20glowing%20powers%2C%20warm%20yellow%20and%20coral%20tones%2C%20playful%20stylized%20comic%20illustration%2C%20dynamic%20manga%20poster%20style&width=600&height=800&seq=work-cover-02&orientation=portrait",
  },
  {
    id: 3,
    title: "逆世剑主",
    category: "武侠玄幻",
    status: "连载中",
    latestChapter: "第 201 话 · 一剑破万法",
    updateDay: "每周六更新",
    tags: ["武侠", "热血", "战斗"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20martial%20arts%20manga%20comic%20cover%20of%20a%20swordsman%20in%20flowing%20robes%20wielding%20a%20glowing%20blade%2C%20dramatic%20coral%20red%20and%20dark%20tones%2C%20powerful%20stylized%20comic%20illustration%2C%20epic%20manga%20poster%20style&width=600&height=800&seq=work-cover-03&orientation=portrait",
  },
  {
    id: 4,
    title: "星际冒险队",
    category: "科幻星际",
    status: "连载中",
    latestChapter: "第 55 话 · 迷途星环",
    updateDay: "每周五更新",
    tags: ["科幻", "太空", "冒险"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20sci-fi%20manga%20comic%20cover%20of%20a%20space%20exploration%20crew%20in%20colorful%20gear%20on%20a%20distant%20planet%2C%20teal%20and%20warm%20coral%20accents%2C%20adventurous%20stylized%20comic%20illustration%2C%20dynamic%20manga%20poster%20style&width=600&height=800&seq=work-cover-04&orientation=portrait",
  },
  {
    id: 5,
    title: "魔女的茶点铺",
    category: "治愈日常",
    status: "完结",
    latestChapter: "第 88 话 · 谢幕之甜",
    updateDay: "已完结",
    tags: ["治愈", "魔法", "日常"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20fantasy%20slice-of-life%20manga%20comic%20cover%20of%20a%20young%20witch%20serving%20pastries%20in%20a%20cozy%20teashop%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20charming%20stylized%20comic%20illustration%2C%20manga%20poster%20style&width=600&height=800&seq=work-cover-05&orientation=portrait",
  },
  {
    id: 6,
    title: "都市传说档案",
    category: "悬疑推理",
    status: "连载中",
    latestChapter: "第 47 话 · 午夜来电",
    updateDay: "每周二更新",
    tags: ["悬疑", "推理", "灵异"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20mystery%20manga%20comic%20cover%20of%20a%20detective%20investigating%20an%20urban%20legend%20under%20neon%20city%20lights%2C%20dark%20teal%20and%20coral%20accents%2C%20atmospheric%20stylized%20comic%20illustration%2C%20manga%20poster%20style&width=600&height=800&seq=work-cover-06&orientation=portrait",
  },
  {
    id: 7,
    title: "拳道少年",
    category: "热血运动",
    status: "连载中",
    latestChapter: "第 133 话 · 决胜之拳",
    updateDay: "每周四更新",
    tags: ["运动", "热血", "励志"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20sports%20fighting%20manga%20comic%20cover%20of%20a%20determined%20boxing%20teenager%20in%20the%20ring%2C%20energetic%20coral%20red%20and%20warm%20amber%20tones%2C%20dynamic%20action%20stylized%20comic%20illustration%2C%20manga%20poster%20style&width=600&height=800&seq=work-cover-07&orientation=portrait",
  },
  {
    id: 8,
    title: "治愈系小森林",
    category: "治愈日常",
    status: "连载中",
    latestChapter: "第 39 话 · 雨后新芽",
    updateDay: "每周日更新",
    tags: ["治愈", "森林", "日常"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20healing%20slice-of-life%20manga%20comic%20cover%20of%20a%20girl%20reading%20under%20a%20big%20tree%20in%20a%20sunlit%20forest%2C%20soft%20green%20and%20warm%20cream%20tones%2C%20gentle%20stylized%20comic%20illustration%2C%20manga%20poster%20style&width=600&height=800&seq=work-cover-08&orientation=portrait",
  },
];

export const categories = ["全部", "奇幻冒险", "青春校园", "武侠玄幻", "科幻星际", "治愈日常", "悬疑推理", "热血运动"];

export const steps = [
  {
    icon: "ri-login-circle-line",
    title: "注册登录",
    desc: "打开汗汗虫虫漫画，用邮箱快速注册账号，一次登录全端同步。",
  },
  {
    icon: "ri-heart-add-line",
    title: "加入追更",
    desc: "浏览作品，把感兴趣的漫画加入追更列表，开始集中管理。",
  },
  {
    icon: "ri-notification-2-line",
    title: "设置提醒",
    desc: "按你的习惯设置更新提醒与推送时间，静默时段自动免打扰。",
  },
  {
    icon: "ri-book-read-line",
    title: "安心阅读",
    desc: "最新章节推送直达，自动续读接上进度，追更日历随时查看更新安排。",
  },
];

export const testimonials = [
  {
    name: "阿楠",
    role: "追更三年 · 追了 23 部",
    quote: "以前每天要刷七八次页面就怕错过，用了追更日历之后终于不用提心吊胆了，哪部哪天更新全写清楚。",
    rating: 5,
  },
  {
    name: "小鹿",
    role: "重度追更党 · 追了 31 部",
    quote: "最新章节推送真的救命，晚上十点更新的作品也会准时提醒，自动续读让我换手机也能一秒接上进度。",
    rating: 5,
  },
  {
    name: "阿澄",
    role: "上班族 · 追了 12 部",
    quote: "订阅管理很干净，把所有作品列得清清楚楚，还能设置静默时段，白天开会也不会被消息打扰。",
    rating: 5,
  },
  {
    name: "柚柚",
    role: "漫龄五年 · 追了 18 部",
    quote: "更新提醒设置灵活，重要作品设成强提醒、日常的静默就好。界面清爽，是我用过最顺手的追更工具。",
    rating: 4,
  },
];

export const faqs = [
  {
    q: "汗汗虫虫漫画的更新提醒会自动开启吗？",
    a: "当你把作品加入追更列表后，系统默认会开启基础更新提醒。你可以在「追更设置」里为每部作品单独调整提醒方式、推送时间与静默时段，完全按你的习惯来。",
  },
  {
    q: "追更日历上会显示哪些内容？",
    a: "追更日历会整理你在追的全部作品，清晰标注每部作品的预计更新日期，以及最近一次的更新状态。已完成的作品也会单独标识，方便你回顾。",
  },
  {
    q: "最新章节推送可以关闭吗？",
    a: "可以。你随时可以在「订阅管理」中一键暂停或开启某部作品的新章节推送，也可以设置全局的免打扰时段，在指定时间不接收任何更新通知。",
  },
  {
    q: "自动续读是如何工作的？",
    a: "自动续读会记录你的最新阅读位置，无论你在手机、平板还是电脑上阅读，只要使用同一账号登录，打开作品都会直接跳转到上次读到的章节，无需手动查找。",
  },
  {
    q: "更换设备后我的追更数据还在吗？",
    a: "在的。追更列表、阅读进度和提醒设置都绑定你的账号并云端同步，更换设备登录同一账号即可完整恢复，追更进度始终跟随你。",
  },
  {
    q: "订阅管理里能看到通知记录吗？",
    a: "可以。「订阅管理」会记录每条推送通知的状态与时间，方便你随时回看近期有哪些作品更新过，不会遗漏任何一次重要更新。",
  },
];

export const contactMeta = [
  { icon: "ri-mail-line", label: "意见反馈邮箱", value: "support@hanhan-manga.example" },
  { icon: "ri-customer-service-2-line", label: "在线客服", value: "工作日 9:00 - 21:00 在线" },
  { icon: "ri-community-line", label: "读者社区", value: "加入追更交流群" },
];